import {Component, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Campaign, getCampaignLocationsI18nMessage} from '../../../services/model';
import {TranslocoDirective, TranslocoService} from '@jsverse/transloco';
import {PillLogoComponent} from '../../pill-logo/pill-logo.component';
import {LoyaltyCurrencyPipe} from '../../pipes/loyalty-currency.pipe';
import {PillColor, PillType} from '../../models';

@Component({
  selector: 'lib-campaign-card-sentence-sponsor',
  imports: [
    CommonModule, TranslocoDirective, PillLogoComponent, LoyaltyCurrencyPipe
  ],
  templateUrl: './campaign-card-sentence-sponsor.component.html',
  styleUrl: './campaign-card-sentence-sponsor.component.scss'
})
export class CampaignCardSentenceSponsorComponent {
  campaign = input.required<Campaign>();

  numberOfLocationsI18nString = computed(() => {
    if (this.campaign().merchant) {
      return this.campaign()!.merchant!.name;
    } else if (this.campaign().locationsGroup != undefined && this.campaign().locationsGroup?.locations?.length !== 0) {
      const message = getCampaignLocationsI18nMessage(this.campaign());

      return this.translocoService.translate(message.i18nMessage, message.params);
    }
    return '';
  });
  protected readonly PillColor = PillColor;
  protected readonly PillType = PillType;

  constructor(private translocoService: TranslocoService) {
  }
}
